import LandingPage from '../modules/ui/pages/LandingPage';
import withGlobalAppLayout from '../modules/ui/containers/HOC/withGlobalAppLayout';
import { ReactElement } from 'react';

// Load the statically generated latest-publication.json
import latestPublicationData from '../../public/latest-publication.json';
import Publication from '../modules/domain/Publication/Publication';

export default function index(props: any): ReactElement
{
    const locale: string = props.pageContext?.locale || 'de';
    const publicationRawData = (latestPublicationData as Record<string, any>)[locale] || null;
    const latestPublication: Publication|null = publicationRawData === null ? null : Publication.Factory().fromApiFullStructure(publicationRawData);

    return withGlobalAppLayout(LandingPage, {
        locale,
        hideGfLogo: true,
        latestPublication,
        ...props,
    });
}
